export default "__VITE_ASSET__2511fb82__"